export const REVENUE_STREAMS = [
  { key: 'tickets', label: 'Tickets', color: '#1982C4' },
  { key: 'fnb', label: 'Food & beverage', color: '#FFB703' },
  { key: 'addons', label: 'Add-ons', color: '#8AC926' },
  { key: 'ticket_charges', label: 'Ticket charges', color: '#5C7CFA' },
  { key: 'memberships', label: 'Memberships', color: '#6A4C93' },
  { key: 'packs_and_passes', label: 'Packs & passes', color: '#2CA8A0' },
  { key: 'classes', label: 'Classes', color: '#7C6FD8' },
  { key: 'donations', label: 'Donations', color: '#E86A92' },
  { key: 'resale_fees', label: 'Resale fees', color: '#F47C2C' },
];

export const CHART_SERIES = [
  ...REVENUE_STREAMS.slice(0, 3),
  { key: 'other', label: 'Everything else', color: '#CBD5E1' },
];
